<template>
  <div>
    <PageHeader title="รายงานสรุปจำนวนผู้เรียนแยกตามโรงเรียน"></PageHeader>
    <b-container class="mt-5">
      <div class="section-container">
        <div class="search-section">
          <p>กรุณาระบุข้อมูลที่ต้องการดาวน์โหลดรายงาน</p>
          <b-row>
            <b-col cols="3">
              <label><strong>วันที่ลงทะเบียน</strong></label>
              <div class="date-range-field">
                <b-input-group>
                  <b-form-input
                    size="sm"
                    type="text"
                    :value="formatEnrollDate"
                    placeholder="เลือกวันที่ลงทะเบียน"
                    disabled
                  />
                  <b-input-group-prepend>
                    <b-button
                      size="sm"
                      variant="secondary"
                      @click="showCalendarRange('course-enroll-date')"
                    >
                      <b-icon icon="calendar-range"></b-icon>
                    </b-button>
                  </b-input-group-prepend>
                </b-input-group>
                <DatePicker
                  v-model="courseEnrollDate"
                  locale="th"
                  id="course-enroll-date"
                  style="
                    display: none;
                    float: right;
                    position: relative;
                    will-change: transform;
                    left: 0px;
                  "
                  is-range
                />
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="3">
              <label><strong>วิชา</strong></label>
              <b-form-select
                v-model="selectedSubject"
                :options="subjectList"
              ></b-form-select>
            </b-col>
            <b-col v-if="isWannasorn" cols="3">
              <label><strong>สถาบัน</strong></label>
              <b-form-select
                v-model="selectedSubCompany"
                :options="subCompanyOptions"
              ></b-form-select>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="3">
              <label><strong>รหัสคอร์ส</strong></label>
              <b-form-input
                v-model="courseIdInputValue"
                type="search"
                class="form-control border-1"
                autofocus
                placeholder="ค้นหารหัสคอร์ส"
              ></b-form-input>
            </b-col>
            <b-col cols="5">
              <label><strong>ชื่อคอร์ส</strong></label>
              <v-select
                v-if="!isLoadingCourses"
                :options="courseList"
                label="courseName"
                v-model="selectedCourse"
                placeholder="พิมพ์ชื่อคอร์สเรียนที่ต้องการค้นหา"
                :clearable="false"
              >
                <template #selected-option="option">
                  {{ truncateMiddle(option.courseName, 45) }}
                </template>
              </v-select>
              <v-select v-else placeholder="กำลังโหลดข้อมูล..." />
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="3">
              <label><strong>ระดับชั้นเรียน</strong></label>
              <b-form-select
                v-model="selectedClassLevel"
                :options="classLevelList"
              ></b-form-select>
            </b-col>
            <b-col cols="5">
              <label><strong>ชื่อโรงเรียน</strong></label>
              <v-select
                v-if="!isLoadingSchool"
                :options="filteredSchools"
                label="value"
                v-model="selectedSchool"
                placeholder="พิมพ์ชื่อโรงเรียนที่ต้องการค้นหา"
                :clearable="false"
                @input="searchSchool = ''"
              >
                <template #search="{ attributes, events }">
                  <input
                    class="vs__search"
                    v-bind="attributes"
                    v-on="events"
                    v-model="searchSchool"
                  />
                </template>
                <template #selected-option="option">
                  {{ truncateMiddle(option.value, 45) }}
                </template>
              </v-select>
              <v-select v-else placeholder="กำลังโหลดข้อมูล..." />
            </b-col>
          </b-row>
          <b-button @click="searchInfo()" class="search-btn" variant="primary">
            <b-icon icon="search"></b-icon>
            ค้นหาข้อมูล
          </b-button>
        </div>

        <div v-if="isShowTable" class="table-section">
          <div class="table-title">
            <p>
              <strong>รายละเอียดจำนวนผู้เรียนแยกตามโรงเรียน</strong>
            </p>
            <b-button @click="generatePdf()" variant="primary">
              <b-icon icon="chevron-double-down"></b-icon>
              ดาวน์โหลดรายงาน pdf
            </b-button>
          </div>
          <p class="remark-text">
            หมายเหตุ : ระบบทำการ generate report เป็นไฟล์ pdf
            และดาวน์โหลดลงบนเครื่องของคุณ
          </p>
          <b-table
            id="student-count-by-school-list"
            :fields="fields"
            :items="studentCountBySchoolList"
            :per-page="perPage"
            :current-page="currentPage"
            responsive
            style="font-size: 14px; border:hidden;"
            :busy="isDataTableLoading"
            hover
            striped
            show-empty
          >
            <template #empty>
              <p class="text-center">ไม่มีข้อมูล</p>
            </template>
          </b-table>
          <b-row class="mt-3" v-if="studentCountBySchoolList.length > 0">
            <b-col cols="6">
              <form class="form-inline">
                <div class="form-group mb-2">
                  <label>แสดง</label>
                </div>
                <div class="form-group ml-2 mb-2">
                  <b-form-select v-model="perPage" size="sm">
                    <option value="10">10</option>
                    <option value="15">15</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                  </b-form-select>
                </div>
                <div class="form-group ml-2 mb-2">
                  <label>
                    จาก
                    {{ studentCountBySchoolList.length }}
                    รายการ
                  </label>
                </div>
              </form>
            </b-col>
            <b-col cols="6" v-if="studentCountBySchoolList.length > 0">
              <nav class="float-right">
                <b-pagination
                  v-model="currentPage"
                  :per-page="perPage"
                  :total-rows="studentCountBySchoolList.length"
                  aria-controls="student-count-by-school-list"
                  last-number
                >
                </b-pagination>
              </nav>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import PageHeader from "../../layouts/PageHeader";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import vSelect from "vue-select";
import moment from "moment";
import api from "@/services/api";
import dateMixin from "@/components/pages/analytics/shared/mixins/date.js";
import generateAttendanceReportPdfMixin from "../../../mixins/generate-attendance-report-pdf-mixin";
import studentCountBySchoolReportMixin from "../../../mixins/student-count-by-school-report-mixin";
import subCompanyFilterMixin from "../../../mixins/sub-company-filter-mixin";
import { mapActions, mapGetters } from "vuex";

export default {
  mixins: [
    dateMixin,
    generateAttendanceReportPdfMixin,
    studentCountBySchoolReportMixin,
    subCompanyFilterMixin,
  ],
  components: {
    PageHeader,
    DatePicker,
    vSelect,
  },
  data() {
    const currentDate = new Date();

    return {
      comId: this.$store.state.Company.companyInfo.id,
      moment: moment,
      courseEnrollDate: {
        start: "",
        end: "",
      },
      selectedSubject: "",
      subjectList: [{ value: "", text: "ทั้งหมด" }],
      courseIdInputValue: null,
      selectedCourse: null,
      courseList: [{ courseName: "คอร์สทั้งหมด" }],
      isLoadingCourses: true,
      selectedClassLevel: "",
      searchSchool: "",
      selectedSchool: null,
      schoolList: [{ value: "ทั้งหมด" }],
      isLoadingSchool: false,
      isShowTable: false,
      isDataTableLoading: false,
      perPage: 10,
      currentPage: 1,
      fields: [
        {
          label: "ชื่อโรงเรียน",
          key: "education",
          formatter: (value) => {
            return value ? "โรงเรียน" + value : "-";
          },
        },
        {
          label: "ระดับชั้นเรียน",
          key: "gradeLevel",
          formatter: (value) => {
            return value ?? "-";
          },
        },
        {
          label: "จำนวนผู้เรียน (คน)",
          key: "enrollCount",
        },
      ],
      isDisableDownloadReportBtn: false,
      year: currentDate.getFullYear(),
      month: currentDate.getMonth() + 1,
      thaiMonths: [
        "มกราคม",
        "กุมภาพันธ์",
        "มีนาคม",
        "เมษายน",
        "พฤษภาคม",
        "มิถุนายน",
        "กรกฎาคม",
        "สิงหาคม",
        "กันยายน",
        "ตุลาคม",
        "พฤศจิกายน",
        "ธันวาคม",
      ],
      pdfOption: {
        orientation: "p",
        format: "a4",
        unit: "px",
        lineHeight: 1.5,
        putOnlyUsedFonts: true,
      },
      pdfConfig: {
        typo: {
          header: 16,
          large: 18,
          normal: 14,
          small: 12,
          extraSmall: 10,
          chartHeader: 18,
        },
        margin: {
          t: 40,
          b: 20,
          l: 40,
          r: 40,
          tChart: 10,
          tHeaderChart: 24,
          bHeaderTable: 5,
        },
        endLarge: 25,
        endNormal: 12,
        endRow: 18,
        endLegend: 32,
      },
    };
  },
  computed: {
    ...mapGetters("ReportManagement", ["studentCountBySchoolList"]),
    userInfo() {
      return JSON.parse(localStorage.getItem("user"));
    },
    currentProfile() {
      return this.getCurrentProfile(this.userInfo.profiles);
    },
    filteredSchools() {
      if (!this.searchSchool) {
        return this.schoolList.slice(0, 50);
      }

      const searchLower = this.searchSchool.toLowerCase();
      const filtered = this.schoolList.filter(
        (option) =>
          option.value && option.value.toLowerCase().includes(searchLower),
      );

      return filtered.slice(0, 50);
    },
    formatEnrollDate() {
      return this.getFormattedRange(
        this.courseEnrollDate.start,
        this.courseEnrollDate.end,
        "course-enroll-date",
      );
    },
    instituteName() {
      if (this.comId == 1000001) {
        return "สถาบันกวดวิชาเคมี อ.อุ๊";
      } else if (this.comId == 1000002) {
        return "สถาบันกวดวิชาแอพพลายด์ฟิสิกส์";
      } else if (this.comId == 1000003) {
        return "สถาบันกวดวิชาไบโอบีม";
      }
      return "-";
    },
    classLevelList() {
      const defaultOption = { value: "", text: "ทั้งหมด" };
      const allLevels = [
        "ป.1",
        "ป.2",
        "ป.3",
        "ป.4",
        "ป.5",
        "ป.6",
        "ม.1",
        "ม.2",
        "ม.3",
        "ม.4",
        "ม.5",
        "ม.6",
      ];

      let levelsToInclude = [];

      // chemou
      if (this.comId === 1000001) {
        levelsToInclude = allLevels;
      } else if ([1000002, 1000003].includes(this.comId)) {
        // appliedphysics biobeam
        levelsToInclude = allLevels.slice(6); // ป.4 - ม.6
      }

      const mappedLevels = levelsToInclude.map((level) => ({
        value: level,
        text: level,
      }));

      return [defaultOption, ...mappedLevels];
    },
    selectedSubjectText() {
      const selected = this.subjectList.find(
        (item) => item.value === this.selectedSubject,
      );

      return selected ? selected.text : "ทั้งหมด";
    },
  },
  async mounted() {
    let courses = [];
    let subjects = [];

    this.setDefaultDates();
    this.fetchSchoolData();

    await api.get(`v1/companies/${this.comId}/courses`).then(({ data }) => {
      courses = data.data;
      this.isLoadingCourses = false;
    });
    this.courseList.push(...courses);

    await api.get(`/v1/courses/academic-data`).then(({ data }) => {
      subjects = data.data.subjects.map((item) => {
        return { value: item.st_id, text: item.st_name };
      });
    });

    this.subjectList.push(...subjects);
    if (this.isWannasorn) {
      this.loadSubCompanyDropdown();
    }
  },
  methods: {
    ...mapActions("ReportManagement", ["fetchStudentCountBySchoolList"]),
    async fetch(params) {
      this.isDataTableLoading = true;
      try {
        await this.fetchStudentCountBySchoolList(params);
      } finally {
        this.isDataTableLoading = false;
      }
    },
    async searchInfo() {
      let params = {
        subjectTypeId: this.selectedSubject || null,
        gradeLevel: this.selectedClassLevel || null,
        courseCode: this.courseIdInputValue || null,
        courseName:
          this.selectedCourse?.courseName === "คอร์สทั้งหมด"
            ? null
            : this.selectedCourse?.courseName,
        education:
          this.selectedSchool?.value === "ทั้งหมด"
            ? null
            : this.selectedSchool?.value,
        startDate: this.courseEnrollDate.start
          ? moment(this.courseEnrollDate.start).format("YYYY-MM-DD")
          : "",
        endDate: this.courseEnrollDate.end
          ? moment(this.courseEnrollDate.end).format("YYYY-MM-DD")
          : "",
        scId: this.selectedSubCompany || null,
      };

      await this.fetch(params);
      this.isShowTable = true;
    },
    async fetchSchoolData() {
      const url =
        "https://s1.coursesquare.co/data/thailand-school/thai-school-list.json";

      try {
        this.isLoadingSchool = true;

        const response = await fetch(url);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await response.json();
        const uniqueData = [
          ...new Map(data.map((item) => [item.id, item])).values(),
        ];
        this.schoolList.push(...uniqueData);
      } catch (error) {
        console.error("เกิดข้อผิดพลาดในการดึงข้อมูล:", error);
      } finally {
        this.isLoadingSchool = false;
      }
    },
    getCurrentProfile(profiles) {
      const requestCompany = this.$route.params.company;
      if (requestCompany) {
        let currentCompany = profiles.find(
          (data) => data.company.url === requestCompany,
        );
        if (currentCompany) return currentCompany;
      } else if (localStorage.getItem("ComId")) {
        const currentComId = localStorage.getItem("ComId");
        let currentCompany = profiles.find(
          (data) => data.company.id == currentComId,
        );
        if (currentCompany) return currentCompany;
      }

      return profiles[0];
    },
    getFormattedRange(startDate, endDate, calendarId) {
      if (!startDate) return "";

      const rangeCalendar = document.getElementById(calendarId);
      if (rangeCalendar && rangeCalendar.style.display === "inline-block") {
        this.showCalendarRange(calendarId);
      }

      const start = moment(startDate).format("DD/MM/YYYY");
      const end = moment(endDate).format("DD/MM/YYYY");
      return `${start} - ${end}`;
    },
    showCalendarRange(calendarId) {
      let rangeCalendar = document.getElementById(calendarId);
      if (rangeCalendar.style.display == "inline-block") {
        rangeCalendar.style.display = "none";
      } else {
        rangeCalendar.style.display = "inline-block";
      }
    },
    setDefaultDates() {
      const dateFormat = "YYYY-MM-DD";
      const currentDate = moment();
      const ninetyDaysAgo = moment(currentDate).subtract(90, "days");

      this.courseEnrollDate.start = ninetyDaysAgo.format(dateFormat);
      this.courseEnrollDate.end = currentDate.format(dateFormat);
    },
    truncateMiddle(text, startChars = 4) {
      if (!text) return "";
      const textStr = String(text);
      if (textStr.length <= startChars) {
        return textStr;
      }
      const start = textStr.substring(0, startChars);
      return `${start}...`;
    },
  },
};
</script>

<style scoped lang="scss">
.section-container,
.search-section {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

.search-section {
  .date-range-field,
  .date-field {
    .form-control:disabled {
      background-color: #fff;
    }
  }

  .search-btn {
    width: fit-content;
  }
}

.table-section {
  display: flex;
  flex-direction: column;
  gap: 25px;

  .table-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
  }

  .remark-text {
    color: #ffc107;
  }
}
/* Calendar */
.vc-container {
  position: absolute !important;
  right: 0 !important;
  left: initial !important;
  margin-right: 13px;
  z-index: 99;
}

/* Target the input search and its placeholder */
::v-deep .vs__search,
::v-deep .vs__search::placeholder {
  margin: 0;
  padding: 3px 3px 2px;
  font-size: 14px;
}
</style>

<style>
/* text field height */
.date-range-field .form-control,
.vs__dropdown-toggle {
  height: 38px;
}

.vs__dropdown-toggle {
  align-items: center;
}

.vs__clear {
  margin-bottom: 6px;
}

.custom-select {
  height: 38px !important;
  padding: 0 1.75rem 0 0.75rem;
  font-size: 14px !important;
}
</style>
